import { BOARD } from "@grundbesitz/shared";
import type { RoomView } from "@grundbesitz/shared";
import { buildWindowInfo } from "../../../lib/assets";
import { secondsUntil } from "../../../lib/store";
import { useTick } from "./useTick";

/** Status of the registration window that opens when the bank is down to its last house or hotel. */
export function BuildWindowNotice({ room }: { room: RoomView }) {
  const game = room.game;
  const info = game ? buildWindowInfo(game, room.you.playerId) : null;
  useTick(info !== null && !info.closing, 500);
  if (!info) return null;

  const seconds = secondsUntil(room.timers.buildWindowEndsAt);
  const others = info.others.map((o) => `${o.name} (${BOARD[o.field].name})`).join(", ");
  const last = `das letzte ${info.noun}`;

  let headline: string;
  if (info.closing) {
    headline = `Ein Bieterverfahren um ${last} läuft.`;
  } else if (info.mine) {
    headline = `Du bist für ${last} angemeldet${seconds !== null ? `, noch ${seconds} s` : ""}.`;
  } else {
    headline = `Anmeldung für ${last} offen${seconds !== null ? `, noch ${seconds} s` : ""}.`;
  }

  return (
    <section
      aria-label="Bauen bei Gebäudemangel"
      className="rounded-xl border border-warn/70 bg-surface p-3 text-sm"
    >
      <p className="font-semibold">{headline}</p>
      <p className="mt-0.5 text-xs text-ink-2">
        {info.closing
          ? "Wer sich angemeldet hat, kann in der Versteigerung mitbieten."
          : "Melden sich mehr Spieler an, als Gebäude da sind, werden sie versteigert. Sonst bekommt jeder sein Gebäude zum Listenpreis."}
      </p>
      {info.mine && (
        <p className="mt-1 text-xs">
          Deine Anmeldung: <strong>{BOARD[info.mine.field].name}</strong>
        </p>
      )}
      {others && (
        <p className="mt-1 text-xs">
          Mitbewerber: <strong>{others}</strong>
        </p>
      )}
    </section>
  );
}
